module.exports = __webpack_public_path__ + "static/media/profile.4f8dbf50.svg";